import { render, staticRenderFns } from "./QuotaTab.vue?vue&type=template&id=4d237dfa&scoped=true"
import script from "./QuotaTab.vue?vue&type=script&lang=js"
export * from "./QuotaTab.vue?vue&type=script&lang=js"
import style0 from "./QuotaTab.vue?vue&type=style&index=0&id=4d237dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d237dfa",
  null
  
)

export default component.exports